import React from 'react';
import styled from 'styled-components';
import { FaTwitter, FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const FooterSection = styled.footer`
  background-color: var(--secondary-color);
  color: var(--white);
  padding: 4rem 0 2rem;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 2rem;
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const FooterCol = styled.div``;

const FooterLogo = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: var(--white);
`;

const FooterDescription = styled.p`
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--white);
  transition: all 0.3s ease;
  
  &:hover {
    background-color: var(--primary-color);
    transform: translateY(-3px);
  }
`;

const FooterTitle = styled.h4`
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: var(--white);
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterLink = styled.li`
  margin-bottom: 0.75rem;
  
  a {
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.95rem;
    
    &:hover {
      color: var(--primary-color);
    }
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin: 3rem 0 2rem;
`;

const Copyright = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

const CopyrightText = styled.p`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
`;

const FooterBottomLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  
  a {
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
    transition: all 0.3s ease;
    
    &:hover {
      color: var(--primary-color);
    }
  }
`;

const StyledLink = styled(Link)`
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  
  &:hover {
    color: var(--primary-color);
  }
`;

const FooterBottomStyledLink = styled(Link)`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    color: var(--primary-color);
  }
`;

const Footer = () => {
  return (
    <FooterSection>
      <Container>
        <FooterGrid>
          <FooterCol>
            <FooterLogo>TinySmart.AI</FooterLogo>
            <FooterDescription>
              Transform your messaging experience with our lightweight hallow-inspired 
              interface powered by advanced AI capabilities with end-to-end encryption.
            </FooterDescription>
            {/* <SocialLinks>
              <SocialIcon href="mailto:contact@tinysmart.ai" aria-label="Email">
                <FaEnvelope />
              </SocialIcon>
              <SocialIcon href="https://linkedin.com/company/tinysmart-ai" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </SocialIcon>
              <SocialIcon href="https://twitter.com/tinysmart_ai" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </SocialIcon>
              <SocialIcon href="https://github.com/tinysmart-ai" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <FaGithub />
              </SocialIcon>
            </SocialLinks> */}
          </FooterCol>
          
          <FooterCol>
            <FooterTitle>Quick Links</FooterTitle>
            <FooterLinks>
              <FooterLink><a href="#features">Features</a></FooterLink>
              <FooterLink><a href="#how-it-works">How It Works</a></FooterLink>
              <FooterLink><a href="#showcase">Product</a></FooterLink>
              <FooterLink><a href="#contact">Contact</a></FooterLink>
            </FooterLinks>
          </FooterCol>
          
          <FooterCol>
            <FooterTitle>Legal</FooterTitle>
            <FooterLinks>
              <FooterLink><StyledLink to="/privacy-policy">Privacy Policy</StyledLink></FooterLink>
              <FooterLink><StyledLink to="/terms-of-service">Terms of Service</StyledLink></FooterLink>
              {/* <FooterLink><StyledLink to="/disclaimer">Disclaimer</StyledLink></FooterLink> */}
              {/* <FooterLink><StyledLink to="/cookie-policy">Cookie Policy</StyledLink></FooterLink> */}
            </FooterLinks>
          </FooterCol>
        </FooterGrid>
        
        <Divider />
        
        <Copyright>
          <CopyrightText>
            © {new Date().getFullYear()} tinysmart.AI. All rights reserved.
          </CopyrightText>
          <FooterBottomLinks>
            <FooterBottomStyledLink to="/privacy-policy">Privacy</FooterBottomStyledLink>
            <FooterBottomStyledLink to="/terms-of-service">Terms</FooterBottomStyledLink>
          </FooterBottomLinks>
        </Copyright>
      </Container>
    </FooterSection>
  );
};

export default Footer; 